import React from "react";
import { Route, Switch } from "react-router-dom";
import AuthRoute from "./AuthRoute";

import Search from "../../../pages/recruiter/Search";
import Dashboard from "../../../pages/dashboard";
import Source from "../../../pages/source/Source";
import ParsedResume from "../../Candidates/ParsedResume";
import Requirements from "../../../pages/requirements/Requirements";
import Singlechat from "../../../pages/chat/Singlechat";
import Projects from "../../../pages/projects";

import CCCandidates from "../../../pages/cc/Candidates";
import CCNew from "../../../pages/cc/dashboard/New";
import CCSTC from "../../../pages/cc/dashboard/Stc";
import CCDocumentColleted from "../../../pages/cc/dashboard/DocumentColleted";
import CCFinalInterviewCompleted from "../../../pages/cc/dashboard/FinalInterviewCompleted";
import CCFinalInterviewScheduled from "../../../pages/cc/dashboard/FinalInterviewScheduled";
import CCInterviewScheduled from "../../../pages/cc/dashboard/InterviewScheduled";
import CCScheduleInterview from "../../../pages/cc/dashboard/ScheduleInterview";
import CCJoined from "../../../pages/cc/dashboard/Joined";
import CCOffered from "../../../pages/cc/dashboard/Offered";
import CCOfferedDeclined from "../../../pages/cc/dashboard/OfferedDeclined";
import CCSalaryBreakup from "../../../pages/cc/dashboard/SalaryBreakup";
import CCYetToJoin from "../../../pages/cc/dashboard/YetToJoin";
import AssignFreelancers from "../../../pages/requirements/AssignFreelancers";
import AssignVendors from "../../../pages/requirements/AssignVendors";
import FreelancerInfo from "../../../pages/users/freelancers/FreelancerInfo";
import VendorInfo from "../../../pages/users/vendor/VendorInfo";
import FreelancerReport from "../../../pages/users/freelancers/FreelancerReport";
import VendorReport from "../../../pages/users/vendor/VendorReport";
import FreeLancers from "../../../pages/users/freelancers/FreeLancers";
import Vendors from "../../../pages/users/vendor/Vendors";
import EmployeeDashboard from "../../../pages/dashboard/dashboardItems/EmployeeDashboard";
import { EmployeeDataProvider } from "../../../context/EmployeeDataContext";

import ApplyLeave from "../../../pages/employee/attendance/ApplyLeave";
import MyOpinions from "../../../pages/employee/opinions/MyOpinions";
import MyFeedback from "../../../pages/employee/opinions/MyFeedback";
import MyConcern from "../../../pages/employee/opinions/MyConcern";
import ApplyPermission from "../../../pages/employee/attendance/ApplyPermission";
import CalendarUI from "../../../pages/employee/calender/CalendarUI";
import MyAppreciation from "../../../pages/employee/certificates/MyAppreciation";
import ProjectDetails from "../../../pages/employee/projectDetails/ProjectDetails";
import Profile from "../../../pages/employee/UserDetails/UserDetails";
import EmployersCertificate from "../../../pages/employee/ViewEmployeeCertificate/EmployersCertificate";
import ViewAttendanceDetails from "../../../pages/employee/attendance/ViewAttendanceDetails";
import ViewJobposting from "../../../pages/employee/internalJobposting/ViewJobposting";
import SeparationTemplate from "../../../pages/employee/separation/SeparationTemplate";
import ViewMyPaySlip from "../../../pages/employee/payslip/ViewMyPaySlip";
import PolicyHandBook from "../../../pages/employee/PolicyHandbook/PolicyHandBook";
import EmployeeTaxDocument from "../../../pages/employee/TaxDocument/EmployeeTaxDocument";
import EmployeeAssetManagement from "../../../pages/employee/assetManagement/EmployeeAssetManagement";

const ClientCoordinatorRoutes = ({ role }) => {
  return (
    <Switch>
      <AuthRoute
        path="/app/dashboard"
        role={role}
        roles={[
          "SUPERADMIN",
          "ADMIN",
          "RECRUITER",
          "CLIENTCOORDINATOR",
          "FREELANCER",
          "SUBVENDOR",
        ]}
        component={Dashboard}
      />
      <AuthRoute
        path="/app/employee_dashboard"
        role={role}
        roles={[
          "SUPERADMIN",
          "ADMIN",
          "RECRUITER",
          "CLIENTCOORDINATOR",
          "FREELANCER",
          "SUBVENDOR",
        ]}
        component={EmployeeDashboard}
      />
      <AuthRoute
        path="/app/search"
        role={role}
        roles={[
          "ADMIN",
          "RECRUITER",
          "CLIENTCOORDINATOR",
          "FREELANCER",
          "SUBVENDOR",
        ]}
        component={Search}
      />
      <AuthRoute
        path="/app/singlechat"
        role={role}
        roles={["SUPERADMIN", "ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={Singlechat}
      />
      <AuthRoute
        path="/app/settings/source"
        role={role}
        roles={["ADMIN", "CLIENTCOORDINATOR"]}
        component={Source}
      />
      <AuthRoute
        path="/app/requirements"
        role={role}
        roles={["ADMIN", "CLIENTCOORDINATOR"]}
        component={Requirements}
      />
      <AuthRoute
        path="/app/parsed_resume"
        role={role}
        roles={[
          "ADMIN",
          "RECRUITER",
          "CLIENTCOORDINATOR",
          "FREELANCER",
          "SUBVENDOR",
        ]}
        component={ParsedResume}
      />
      <AuthRoute
        path="/app/assign_freelancers"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={AssignFreelancers}
      />
      <AuthRoute
        path="/app/assign_vendors"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={AssignVendors}
      />

      <Route path="/app/freelancer">
        <AuthRoute
          path=""
          role={role}
          roles={["CLIENTCOORDINATOR"]}
          component={FreeLancers}
        />
        <AuthRoute
          path="/app/freelancer/requirements"
          role={role}
          roles={["CLIENTCOORDINATOR"]}
          component={FreelancerInfo}
        />
        <AuthRoute
          path="/app/freelancer/reports"
          role={role}
          roles={["CLIENTCOORDINATOR"]}
          component={FreelancerReport}
        />
      </Route>
      <Route path="/app/vendor">
        <AuthRoute
          path=""
          role={role}
          roles={["CLIENTCOORDINATOR"]}
          component={Vendors}
        />
        <AuthRoute
          path="/app/vendor/requirements"
          role={role}
          roles={["CLIENTCOORDINATOR"]}
          component={VendorInfo}
        />
        <AuthRoute
          path="/app/vendor/reports"
          role={role}
          roles={["CLIENTCOORDINATOR"]}
          component={VendorReport}
        />
      </Route>

      <AuthRoute
        path="/app/cc_candidates"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCCandidates}
      />
      <AuthRoute
        path="/app/cc_candidates_new"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCNew}
      />
      <AuthRoute
        path="/app/cc_candidates_stc"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCSTC}
      />
      <AuthRoute
        path="/app/cc_candidates_interview_scheduled"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCInterviewScheduled}
      />
      <AuthRoute
        path="/app/cc_candidates_schedule_interview"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCScheduleInterview}
      />
      <AuthRoute
        path="/app/cc_candidates_fis"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCFinalInterviewScheduled}
      />
      <AuthRoute
        path="/app/cc_candidates_fic"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCFinalInterviewCompleted}
      />
      <AuthRoute
        path="/app/cc_candidates_document_collected"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCDocumentColleted}
      />
      <AuthRoute
        path="/app/cc_candidates_salary_breakup_shared"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCSalaryBreakup}
      />
      <AuthRoute
        path="/app/cc_candidates_offered"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCOffered}
      />
      <AuthRoute
        path="/app/cc_candidates_joined"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCJoined}
      />
      <AuthRoute
        path="/app/cc_candidates_offer_declined"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCOfferedDeclined}
      />
      <AuthRoute
        path="/app/cc_candidates_yet_to_join"
        role={role}
        roles={["CLIENTCOORDINATOR"]}
        component={CCYetToJoin}
      />

      <AuthRoute
        path="/app/projects"
        role={role}
        roles={["ADMIN", "CLIENTCOORDINATOR"]}
        component={Projects}
      />

      <Route path="/app/opinions">
        <AuthRoute
          path=""
          role={role}
          roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
          component={MyOpinions}
        />
        <AuthRoute
          path="/app/opinions/feedback"
          role={role}
          roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
          component={MyFeedback}
        />
        <AuthRoute
          path="/app/opinions/concern"
          role={role}
          roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
          component={MyConcern}
        />
      </Route>
      <AuthRoute
        path="/app/apply-leave"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ApplyLeave}
      />
      <AuthRoute
        path="/app/apply-permission"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ApplyPermission}
      />
      <AuthRoute
        path="/app/calendar"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={CalendarUI}
      />
      <Route
        path="/app/payslip"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ViewMyPaySlip}
      />
      <Route
        path="/app/appreciations"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={MyAppreciation}
      />
      <Route
        path="/app/project-details"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ProjectDetails}
      />
      <Route
        path="/app/profile"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={Profile}
      />
      <Route
        path="/app/my-appreciations"
        role={role}
        roles={["EMPLOYEE"]}
        component={EmployersCertificate}
      />
      <Route
        path="/app/attendance"
        role={role}
        roles={["EMPLOYEE"]}
        component={ViewAttendanceDetails}
      />
      <Route
        path="/app/jobpostings"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ViewJobposting}
      />
      <Route
        path="/app/policy-handbook"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={PolicyHandBook}
      />
      <Route
        path="/app/separation"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={SeparationTemplate}
      />
      <Route
        path="/app/tax-document"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={EmployeeTaxDocument}
      />
      <Route
        path="/app/company-assets"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={EmployeeAssetManagement}
      />
    </Switch>
  );
};

export default ClientCoordinatorRoutes;
